import './404.html';
import '@sport/favicon';
import '@sport/res';
import './main.scss';

import './firebase-config.js';

import 'core-js/stable/array/flat-map';
import { Suspense } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, HashRouter } from 'react-router';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import { hydrateRoot, createRoot } from 'react-dom/client';

import { GlobalLoadingSpinner } from '@labradorsports/components';
import {
    AppWrapper,
    Content,
    getSettings,
    initEnv,
    SiteGlobalsProvider,
    RouterStateProvider,
    initDatadog,
} from '@labradorsports/ui';
import { SiteContext } from '@labradorsports/utils';
import { Config, TestUrl, RenderingConfig } from '@sport';

import './app/assets.js';

const settings = getSettings();

const env = {
    ...initEnv(Config, TestUrl),
    ...settings,
};

if (!E2E && !SSR) {
    initDatadog(Config.SiteConfig.Site, env.baseUrl);
}

const Router = APP ? HashRouter : BrowserRouter;

const rootElement = document.getElementById('react');

const cache = createCache({ key: 'css' });

if (APP) {
    window.__SSR_STATE__ = {};
}

const rootContent = (
    <CacheProvider value={cache}>
        <HelmetProvider>
            <SiteContext.Provider
                value={{
                    Config,
                    ...RenderingConfig,
                    env,
                }}
            >
                <Suspense fallback={<GlobalLoadingSpinner />}>
                    <SiteGlobalsProvider>
                        <Router>
                            <RouterStateProvider>
                                <AppWrapper>
                                    <CssBaseline />
                                    <Content />
                                </AppWrapper>
                            </RouterStateProvider>
                        </Router>
                    </SiteGlobalsProvider>
                </Suspense>
            </SiteContext.Provider>
        </HelmetProvider>
    </CacheProvider>
);

if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, rootContent);
} else {
    const root = createRoot(rootElement);
    root.render(rootContent);
}
